"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactRoutes = void 0;
var ContactRoutes;
(function (ContactRoutes) {
    ContactRoutes["BasePrefix"] = "contacts";
    ContactRoutes["ById"] = ":contactId";
    ContactRoutes["AllByClient"] = "all/:clientId";
    ContactRoutes["List"] = "list";
})(ContactRoutes = exports.ContactRoutes || (exports.ContactRoutes = {}));
